import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { getDomainUrl } from 'utils/sourceUtil'
import StreamSymbol from 'enums/StreamSymbol'
import { useTranslation } from 'react-i18next'
import DomainIcon from './DomainIcon'
import Link from './Link'
import { useContextMediaDetail } from './context'

const StyledLink = styled(Link)<{ disabled?: boolean }>`
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`

interface DomainLinkProps {
  domain?: string
  dataStream?: string
}

const DomainLink = ({
  domain: domainFromProp,
  dataStream: dataStreamFromProp
}: DomainLinkProps) => {
  const displayTheme = useDisplayTheme()
  const { t } = useTranslation()
  const { domain: domainFromContext, dataStream: dataStreamFromContext } = useContextMediaDetail()

  const domain = domainFromProp || domainFromContext
  const dataStream = dataStreamFromProp || dataStreamFromContext

  const vocDomain = domain ? `: ${domain}` : ''
  const tooltipContent = dataStream === StreamSymbol.VOC ? `VoC${vocDomain}` : domain
  const url = getDomainUrl(domain)

  return (
    <Tooltip mode={displayTheme} content={!url ? t('soundbiteNoUrl') : tooltipContent}>
      <StyledLink href={!url ? undefined : url} disabled={!url}>
        <DomainIcon domain={domain} dataStream={dataStream} />
      </StyledLink>
    </Tooltip>
  )
}

export default DomainLink
